import { useExploreFacade } from 'features/explore/model/hooks/use-explore-facade';
import { useEventRefresher } from '@zdrbm/zdr-react';
import { useEffect } from 'react';
import { IPoi } from 'features/explore/model/poi-model/poi';
import { PlaceType } from '@placer-ui/types';

export function usePOI(id?: string, poiType?: PlaceType): IPoi | undefined {
    const exploreFacade = useExploreFacade();
    const exploreModel = exploreFacade?.getExplore();

    const poi = id ? exploreModel?.poiCollection.getItem(id) : undefined;

    useEventRefresher(exploreModel?.poiCollection.itemsAdded);
    useEventRefresher(poi?.propertyChanged);

    useEffect(() => {
        if (id && poiType && exploreFacade) {
            exploreFacade.ensurePOILoaded(id, poiType);
        }
    }, [exploreFacade, id, poiType]);

    if (!id || !exploreModel) return undefined;

    return exploreModel.poiCollection.getItem(id);
}
